export const setErrorAction = (show, error) => ({
  widget: 'global',
  type: 'errorSet',
  payload: {
    show,
    error,
  },
})



// WEBPACK FOOTER //
// ./src/global/actions/errorSet.js